import React from 'react';
import { Alert, Button, Modal, Spinner } from 'react-bootstrap';

// «Siniestro ya existe»: se muestra al salir de siniestro/patente cuando ya hay un caso con el mismo siniestro, patente y tipo de gestión.
//  · «Sí, actualizar»: precarga los datos del caso y la pantalla pasa a modo edición.
//  · «No»: el formulario se limpia por completo y sigue como un ingreso nuevo.
const ModalExistente = ({ show, idCaso, cargando, error, onActualizar, onNuevo }) => (
    <Modal show={show} backdrop="static" centered>
        <Modal.Header>
            <Modal.Title as="h5">Siniestro ya existe</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {error ? <Alert variant="danger">{error}</Alert> : null}
            <p className="mb-0">
                Ya existe el caso <b>{idCaso}</b> con este siniestro y esta patente. ¿Desea actualizarlo?
            </p>
            <p className="text-muted small mt-2 mb-0">
                Si responde «No», el formulario se limpia por completo y puede ingresar un caso nuevo.
            </p>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="outline-secondary" onClick={onNuevo} disabled={cargando}>No, ingresar uno nuevo</Button>
            <Button variant="success" onClick={onActualizar} disabled={cargando}>
                {cargando
                    ? <span><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Cargando...</span>
                    : 'Sí, actualizar'}
            </Button>
        </Modal.Footer>
    </Modal>
);

export default ModalExistente;
